import { CoveragePlan } from './components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import { updateProductPlan } from './actions'
import { getBasicPlanOptions } from './selectors'

import {
  toggleRider,
  editRiderSumAssured,
  editRiderSelectedPlan,
} from 'quick-quote/product-common/coverage-plan/actions'

import {
  getAvailableRiderCodes,
  getBasicPremiumState,
  getReadOnlyFields,
  getSumAssured,
  haveBasicPremiumState,
} from 'quick-quote/product-common/coverage-plan/selectors'

const mapStateToProps = (state) => ({
  canProceedToCoveragePlan: canProceedToCoveragePlan(state),
  riderCodes: getAvailableRiderCodes(state),
  basicPlanOptions: getBasicPlanOptions(state),
  selectedBasicPlanCode: getSumAssured(state),
  basicPremiumState: getBasicPremiumState(state),
  haveBasicPremiumState: haveBasicPremiumState(state),
  readOnlyFields: getReadOnlyFields(state),
})

const mapDispatchToProps = (dispatch) => ({
  toggleRider: bindActionCreators(toggleRider, dispatch),
  editRiderSumAssured: bindActionCreators(editRiderSumAssured, dispatch),
  editRiderSelectedPlan: bindActionCreators(editRiderSelectedPlan, dispatch),
  updateSelectedBasicPlan: bindActionCreators(updateProductPlan, dispatch),
})

export const CoveragePlanContainer = connect(mapStateToProps, mapDispatchToProps)(CoveragePlan)
